module.exports = __webpack_public_path__ + "static/img/2_1_5.d12468cd.jpg";